module.exports = __webpack_public_path__ + "img/b2f3e1dbb78406ae45a02b9b9b56dbaf.png";